import type { Series, SingleSeries } from './types'

export const getCurrentSeriesPositionIndex = (
  seriesId: SingleSeries['id'],
  series: Series,
  currentPage: number,
  pageSize: number,
) => {
  const index = series.findIndex((series) => series.id === seriesId) + 1

  return pageSize * (currentPage - 1) + index
}

export const getUpdatedSeriesPositionIndex = (
  type: 'TOP' | 'BOTTOM' | 'EXACT',
  updatedIndex: number,
  totalSeriesCount: number,
) => {
  return {
    TOP: 0,
    BOTTOM: totalSeriesCount - 1,
    EXACT: updatedIndex - 1,
  }[type]
}
